import React, { useEffect, useCallback, useState, useRef, useContext, useMemo } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import CustomPasteModule from '../../artboard/Page/CustomPasteModule';
import CustomQuillHistory from './CustomQuillHistoryModule';
import CustomBlocks from './CustomQuillListModule';
import CustomTooltipModule from './CustomTooltipModule';
import MentionEmbed from '../../artboard/Page/MentionEmbed';
import { getElementBySelectorAsync } from './complexDocumentHelper';
import TextBlockToolbar from './TextBlockToolbar';
import { FontsContext } from '../../context/fontsContext';
import _, { isArray } from 'underscore';
import { generateAndInsertText, getBounds, getAllTextNodesWithinElement } from '../../utils/TextBlockHelper';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../context/complexDocumentContext';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { ComplexTextEditingContext } from '../../context/complexTextEditingContext';
import { dummyCallback, PERFECTDOC_RELATIONSHIP, EMPTY_ARRAY } from '../../utils/complexDocumentConstants';
import { COMPLEX_PAGE_OPTIONS, LOGIC_LIST_DESC } from './translationValues';
import ContextMenu from '../../artboard/ContextMenu';
import { QuillContainer } from './styles';
import VariableMention from '../../artboard/Page/VariableModule';
import VariableMentionPopup from '../EmailDesignPage/EmailBuilder/VariableMentionPopup';
import { DateVar } from '../EmailDesignPage/InputWithVariable/styles';
import { Icon, Popover, Select, Tooltip, message } from 'antd';
import { CancelButton, PopupActionContainer, PopupContainer, PopupLabel, SaveButton } from '../../artboard/Page/styles';
import { UPDATE_DATE_VARIABLE_FORMAT_POPUP } from '../../artboard/translationValues';
import { isTocBlock } from '../../utils/helper';
import LogicMentionPopup from '../EmailDesignPage/EmailBuilder/LogicMentionPopup';
import LogicMention from '../../artboard/Page/LogicModule';
import CustomLogicPopup from '../EmailDesignPage/EmailBuilder/CustomLogicPopup';
const Delta = Quill.import('delta');
const Parchment = Quill.import('parchment');
Quill.DEFAULTS = { ...Quill.DEFAULTS, strict: false };

const FORMATS = [
    'font',
    'block-font',
    'size',
    'block-size',
    'bold',
    'block-bold',
    'italic',
    'block-italic',
    'underline',
    'list',
    'bullet',
    'align',
    'indent',
    'link',
    'color',
    'block-color',
    'background',
    'block-background',
    'mention',
    'lineheight',
    'letterspace',
    'textTransform',
    'dateFormat',
    'heading',
    'block-start',
    'script'
];

const DEBOUNCE_TIME_OUT = 300;

const logger = dummyCallback;
// const logger = console.log;
const NAMESPACES = ['COMPLEX_PAGE_OPTIONS', 'UPDATE_DATE_VARIABLE_FORMAT_POPUP'];

const { CustomBlockBlot, CustomFontAttributor, CustomQuillListItemModule } = CustomBlocks;

const TextBlockWithQuillRenderer = (
  {
    saveBlock,
    defaultContent,
    itemUUID,
    selected,
    value,
    children,
    adjustScroll = dummyCallback,
    enableSideBar = dummyCallback,
    isFromCreativeBlock = false,
    onContainerSingleClick = dummyCallback,
    onContainerClick = dummyCallback,
    backgroundColor = 'transparent',
    customClassName = '',
    padding = {    
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    scaling = 1,
    isPlaceholderVisible = false,
    isFontSidebarAbsolute = false,
    isPreview = false,
    updateOverflowContents = undefined,
    removeTextFromParentPage = undefined,
    toolbarDOM = 'document-editor-toolbar',
    variableDOM = 'variable-menu-container',
    noFocus = false,
    invisible = false,
    editable = true,
    enableAI = true,
    toolbarInvisible = false,
    onMouseMove = dummyCallback,
    textEditable,
    setTextEditable,
    exposeRef = true,
    isHeaderEelement= false,
    getEditorContentLength,
    isMailSubject = false,
    customizeHistory = true,
    customBlurHandler = dummyCallback,
    allowLocal = false,
    onUpdateLocalVariables = dummyCallback,
    border_radius = '0px',
    enableFunctionCall = false,
    relationships =[],
    levels=[],
    isCreativeStaticBlock = false
  },
  ref,
) => {
  const accessibilitySelector = useCallback(store => store[CONTEXT_KEYS.DISABLE_VARIABLE_MENTION], []);
  const [disableVariableMention] = useArtboardContext(accessibilitySelector);
  const editorRef = useRef(null);
  const contentRef = useRef(null);
  const parentStyleRef = useRef(null);
  const historyRef = useRef({ undo: 0, redo: 0 });
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const { t } = useTranslation(NAMESPACES);
  const [forceRender, toggleToolbarForceRender] = useState(false);
  const { Option } = Select;

  const { fontList } = useContext(FontsContext);
  const fontListRef = useRef(fontList);
  const editorMap = useContext(ComplexTextEditingContext);
  const defaultContentRef = useRef(defaultContent);

  const [editorContentDiff, setEditorContentDiff] = useState(defaultContent);

  const [assignVariblePopup, setAssignVariablePopup] = useState({
    isVisible: false,
    left: 0,
    top: 0,
  });
  let position = { top: 0, left: 0 };

  const [showMentionPopup, toggleShowMentionPopup] = useState(false);
  const [showLogicMentionPopup, toggleShowLogicMentionPopup] = useState(false);
  const [showCustomLogicPopup, toggleCustomLogicPopup] = useState(false);
  const [variableTerm, setVariableTerm] = useState('');
  const [logicTerm, setLogicTerm] = useState('');
  const [variablePosition, setVariablePosition] = useState({});
  const [logicPosition, setLogicPosition] = useState({});
  const [customLogicPosition, setCustomLogicPosition] = useState({});
  const [selectedDateVar, setSelectedDateVar] = useState('');
  const [editIconClicked, setEditIconClicked] = useState(false);
  const [defaultCustomLogicContent, setDefaultCustomLogicContent] = useState('');
  const changedFormatRef = useRef();
  const setChangedFormat = value => {
    changedFormatRef.current = value;
  };
  const [, updateArtboard] = useArtboardContext(dummyCallback, `TextBlockWithQuillRenderer-${itemUUID}`);

  const customCurrentBlockSelector = useCallback((store) => store[CONTEXT_KEYS.CURRENT_BLOCK], []);
  const [currentEditingBlock] = useArtboardContext(customCurrentBlockSelector);

  const noVariablesDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN] || store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [disableVariables] = useArtboardContext(noVariablesDesignSelector, `TextBlockWithQuillRenderer-${itemUUID}`);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexArtboard`);

  useMemo(() => {
  if (disableVariableMention) return;

  let blockFontFamily = new CustomFontAttributor('block-font', '--font-family', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockFontFamily, true);
  Quill.register('attributors/style/block-font', blockFontFamily, true);

  const blockStart = new CustomFontAttributor('block-start', '--block-start', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockStart, true);
  Quill.register('attributors/style/block-start', blockStart, true);
  
  let blockHeading = new CustomFontAttributor('heading', '--heading', {
    scope: Parchment.Scope.INLINE,
  });
  Quill.register(blockHeading, true);
  Quill.register('attributors/style/heading', blockHeading, true);

  let blockFontSize = new CustomFontAttributor('block-size', '--font-size', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockFontSize, true);
  Quill.register('attributors/style/block-size', blockFontSize, true);

  let blockBold = new CustomFontAttributor('block-bold', '--bold', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockBold, true);
  Quill.register('attributors/style/block-bold', blockBold, true);

  let blockItalic = new CustomFontAttributor('block-italic', '--italic', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockItalic, true);
  Quill.register('attributors/style/block-italic', blockItalic, true);

  let blockColor = new CustomFontAttributor('block-color', '--color', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockColor, true);
  Quill.register('attributors/style/block-color', blockColor, true);

  let blockBgColor = new CustomFontAttributor('block-background', '--background', {
    scope: Parchment.Scope.BLOCK,
  });
  Quill.register(blockBgColor, true);
  Quill.register('attributors/style/block-background', blockBgColor, true);

  //Registering Attributes
  var Size = Quill.import('attributors/style/size');
  Size.whitelist = null;
  Quill.register(Size, true);
  Quill.register('modules/clipboard', CustomPasteModule, true);
  Quill.register('modules/history', CustomQuillHistory, true);
  if (!disableVariables) {
    Quill.register("modules/variableMention", VariableMention);
  }
  if(enableFunctionCall){
    Quill.register("modules/logicMention", LogicMention);
  }
  Quill.register("modules/customTooltip", CustomTooltipModule);
  Quill.register(MentionEmbed);

  Quill.register('blots/block', CustomBlockBlot);
  Quill.register('formats/list/item', CustomQuillListItemModule);

  let textTransform = new Parchment.Attributor.Style('textTransform', 'text-transform', {
    whitelist: ['capitalize', 'uppercase', 'lowercase', 'none'],
    scope: Parchment.Scope.INLINE,
  });
  Parchment.register(textTransform);

  let baseline = new Parchment.Attributor.Style('baseline', 'script', {
    scope: Parchment.Scope.INLINE,
  });
  Parchment.register(baseline);

  const lineHeightAttribute = new Parchment.Attributor.Style('lineheight', 'line-height', {
    whitelist: null,
    scope: Parchment.Scope.BLOCK,
  });
  Parchment.register(lineHeightAttribute);

  let fontFamilyStyle = new Parchment.Attributor.Style('font', 'font-family', {
    whitelist: null,
    scope: Parchment.Scope.INLINE,
  });
  Parchment.register(fontFamilyStyle);

  let isVariable = new Parchment.Attributor.Attribute('assignedVariable', 'assignedVariable', {
    scope: Parchment.Scope.INLINE,
  });
  // Quill.register(isVariable, true);

  /*let previousFontSize = new Parchment.Attributor.Attribute('previousFontSize', 'data-fontsize', {
    scope: Parchment.Scope.INLINE,
  });
  Quill.register(previousFontSize, true);*/

  let dateFormat = new Parchment.Attributor.Attribute('dateFormat', 'dateFormat', {
    scope: Parchment.Scope.INLINE,
  });
  Quill.register(dateFormat, true)

  const letterspaceStyle = new Parchment.Attributor.Style('letterspace', 'letter-spacing', {
    scope: Parchment.Scope.INLINE,
  });
  Parchment.register(letterspaceStyle);

  // Quill.register('formats/listItem', CustomQuillListItemModule, true);
  // Quill.register('formats/AssignVariable', AssignVariable);

  }, [disableVariableMention, disableVariables, enableFunctionCall])

  // const debouncedSendRequest = useRef(_.debounce(saveBlock, DEBOUNCE_TIME_OUT)).current;
  const debouncedSendRequest = useCallback(_.debounce(saveBlock, DEBOUNCE_TIME_OUT), [saveBlock]);

  const onChange = useCallback((changeType, undoDiff, redoDiff) => {
    logger("On change called ", changeType, undoDiff, redoDiff);
    historyRef.current.op = changeType;
    if (changeType === 'record') {
      historyRef.current.undo = undoDiff;
      historyRef.current.redo = redoDiff;
    } /*else if (changeType === 'undo' || changeType === 'redo') {
      saveBlock(editor.getContents());
    }*/
  }, []);

  const onHistoryChange = useCallback((historyStack) => {
    editorMap.current.set(itemUUID, historyStack);
  }, [itemUUID, editorMap]);

  const quillContentChangeHandler = (html, delta, source) => {
    if (!editorRef.current || source !== 'user') return;
    let editor = editorRef?.current.getEditor();
    if(getEditorContentLength) {
      getEditorContentLength(editor.getLength());
    }
    logger('quillContentChangeHandler : Editor', editor.getContents(), delta, historyRef.current);

   // TODO : Can use reference instead of state - to check if hover experience has to be retained
    setEditorContentDiff(existingContents => {
      if(!existingContents){
        return;
      }
      // Capture empty content case and apply previous formatting from existingContents
      if (delta.ops.length === 1 && Object.keys(delta.ops[0]).includes('delete') && !Object.keys(delta.ops[0]).includes('retain') && existingContents?.ops[0]?.attributes) {
        Object.keys(existingContents?.ops[0]?.attributes).forEach(key => {
          editor.format(key, existingContents.ops[0].attributes[key], 'user');
        });
      }/* else if (Object.keys(delta.ops[0]).includes('insert') && !Object.keys(delta.ops[0]).includes('attributes') && existingContents?.ops[0]?.attributes) { // Capture replaced content case and apply previous formatting from existingContents
        if (delta.ops[0].insert.length === editor.getLength() - 1) { // Replacement
          Object.keys(existingContents?.ops[0]?.attributes).forEach(key => {
            let value = existingContents.ops[0].attributes[key];
            if (key.startsWith('block-')) {
              if (value === 'normal') {
                value = false;
              }
            }
            editor.formatText(0, editor.getLength(), key.replaceAll('block-', ''), value, 'user');
          });
        }
      }*/
      debouncedSendRequest(
        editor.getContents(),
        historyRef.current.undo,
        historyRef.current.redo,
        () => {
          // console.log("Resetting history reference");
          historyRef.current = { undo: 0, redo: 0, op: undefined };
          parentStyleRef.current = undefined;
          // console.log("Undo length :: ", editor.history.stack[HISTORY_OPERATION.UNDO], editor.history.stack[HISTORY_OPERATION.REDO])
        },
        parentStyleRef.current,
        historyRef.current.op,
        globalVariables
      );
      return editor.getContents();
    });

    adjustScroll();
    /*let nodeList = document.querySelectorAll('ol li > :first-child');
    for (let i = 0; i < nodeList.length; i++) {
      nodeList[i].parentElement.style.fontSize = nodeList[i].style.fontSize;
      nodeList[i].parentElement.style.color = nodeList[i].style.color;
    }*/
  };

  const quillContentSelectionHandler = (range, source) => {
    // TODO : Is this needed to populate toolbar?
    if (source === 'silent' || !range) {
      return;
    }
    let editor = editorRef?.current?.getEditor();
    if (!editorRef.current) return;
    if (source === 'user') {
      toggleToolbarForceRender(currentValue => !currentValue);
      // console.log("native range :: ", editor.selection.getNativeRange());
    }
  };

  const quillFocusHandler = (e, source) => {
    logger('Quill getting focused :: ', e, source);
    if (source === 'user') {
      if (editorRef.current) {
        let editor = editorRef?.current.getEditor();
        // editor.setSelection(editor.getLength(), 0);
      }
    } else if (source === 'api' && invisible) {
      let editor = editorRef?.current.getEditor();
      editor.setSelection(0, editor.getLength());
    }
  };

  const quillBlurHandler = (e, source) => {
    logger('Quill getting blurred :: ', e, source);
    var element = document.getElementById(toolbarDOM);
    var element_sidebar = document.getElementById('sidebar-absolute-container');
    if (
      element.parentNode.querySelector(':hover') === element ||
      element_sidebar.parentNode.querySelector(':hover') === element_sidebar
    ) {
      // Inside toolbar
    } else {
      // outside toolbar
    }
    if (customBlurHandler) customBlurHandler();
  };

  const quillUndo = () => {
    let editor = editorRef?.current.getEditor();
    return editor.history.undo();
  };

  const quillRedo = () => {
    let editor = editorRef?.current.getEditor();
    return editor.history.redo();
  };

  useEffect(() => {
    if (!fontList) {
      return;
    }
    let Font = Quill.import('attributors/style/font');
    // We do not add Sans Serif since it is the default
    Font.whitelist = fontList?.fontVarients?.map(inst => inst.name);
    Quill.register(Font, true);
    fontListRef.current = fontList;
  }, [fontList]);

  const hoverListener = e => {
    logger('hoverListener', e.target.getAttribute('assignedVariable'));

    let rect = e.target.getBoundingClientRect();
    logger(rect.top, rect.right, rect.bottom, rect.left);

    let targetElement = document.getElementById('variableTooltipPopUp');

    targetElement.style.top = rect.top - e.target.offsetHeight - 10 + 'px';
    targetElement.style.left = rect.left + 'px';
    targetElement.style.display = 'block';

    targetElement.style.height = e.target.offsetHeight + 'px';

    targetElement.style.display = 'flex';
    targetElement.innerText = e.target.getAttribute('assignedVariable');
  };

  const hoverOutListener = e => {
    logger('hoverOutListener', e.target.getAttribute('assignedVariable'));
    let targetElement = document.getElementById('variableTooltipPopUp');
    targetElement.style.display = 'none';
  };

  const clickListener = e => {
    e.target.removeAttribute('assignedVariable');
    let targetElement = document.getElementById('variableTooltipPopUp');
    targetElement.style.display = 'none';
  };

  useEffect(() => {
    let targetElements = document.querySelectorAll('span[assignedVariable]');

    Array.from(targetElements).map(targetElement => {
      targetElement.addEventListener('mouseenter', hoverListener);

      targetElement.addEventListener('dblclick', clickListener);

      targetElement.addEventListener('mouseleave', hoverOutListener);
    });

    return () => {
      Array.from(targetElements).map(targetElement => {
        targetElement.removeEventListener('mouseenter', hoverListener);

        targetElement.removeEventListener('mouseleave', hoverOutListener);
      });
    };
  }, [editorContentDiff]);

  const variablesSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES], []);
  const [globalVariables, methods] = useDocumentContext(
    variablesSelector,
    `TextBlockWithQuillRenderer-${itemUUID}`,
  );
  const localVariablesSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.LOCAL_VARIABLES], []);
  const [localVariables] = useDocumentContext(
    localVariablesSelector,
    `TextBlockWithQuillRenderer-${itemUUID}`,
  );
  const isTocTitleBlock = useMemo(() => isTocBlock(currentEditingBlock, methods), [currentEditingBlock, methods]);
  const addNewVariable = useMemo(() => methods.addNewVariable, []);

  const [readOnly, setReadOnly] = useState(true);
  let editor = editorRef?.current?.getEditor();

  useEffect(() => {
    dateFormatOption();
  }, [defaultContent]);

  useEffect(() => {
    if (selected) {
      if (!isFromCreativeBlock && !textEditable) {
        setTextEditable(true);
        requestAnimationFrame(() => {
          const editor = editorRef?.current?.getEditor();
          if (editor) {
            editor.setSelection(editor.getLength());
            editor.focus();
          }
        });
      }
      setReadOnly(() => {
        let editor = editorRef?.current?.getEditor();
        if (editor && !isFromCreativeBlock) {
          getElementBySelectorAsync(`#q-container-${itemUUID}`).then(() => {
            editor.focus();
            toggleToolbarForceRender(currentValue => !currentValue);
          });
        }
        return false;
      });
      if (editorRef.current && exposeRef) {
        updateArtboard({
          [CONTEXT_KEYS.TEXT_ELEMENT_REF]: editorRef,
        });
      }
      // Commented out because when focus is lost due to selection of other editors, depending on the order of
      // elements the reference becomes null
      /*return () => {
        console.log("text element unselected :: ", editorRef);
        updateArtboard({
          [CONTEXT_KEYS.TEXT_ELEMENT_REF]: null,
        });
      };*/
    } else {
      setReadOnly(true);
      toggleVariablePopup(false);
      toggleCustomLogicPopup(false);
      toggleShowLogicMentionPopup(false);
      if (editor) {
        editor.blur();
      }
    }
  }, [selected, isFromCreativeBlock, exposeRef]);

  useEffect(() => {
    if (textEditable && !invisible && exposeRef) {
      requestAnimationFrame(() => {
        updateArtboard({
          [CONTEXT_KEYS.TEXT_ELEMENT_REF]: editorRef,
        });
      });
    }
  }, [textEditable, invisible])

  const editorFontResize = useCallback(e => {
       let editor = editorRef?.current.getEditor();
       const { scaling } = e.detail;
       if (editor) {
         const newContents = editor.getContents().ops.map(content => {
           if (content.attributes?.size) {
             let previousFontSize = content.attributes?.previousFontSize ? Number.parseFloat(content.attributes?.previousFontSize) : undefined;
             if (previousFontSize === undefined) {
               previousFontSize = Number.parseFloat(`${content.attributes.size}`.replaceAll('px', '')).toFixed(3);
             }
             let newSize = previousFontSize * scaling;
             return Object.assign({}, content, {
               attributes: Object.assign({}, content.attributes, {
                 size: `${newSize}px`,
                 previousFontSize
               })
             })
           }
           return content;
         });
         logger("After :: ", scaling, JSON.parse(JSON.stringify(editor.history.stack)));
         const change = editor.setContents(newContents, 'silent');
         logger("newContents :: ", newContents, change);
       }
     }, []);

  const debouncedResizeRequest = useRef(_.debounce(editorFontResize, DEBOUNCE_TIME_OUT)).current;

  const onTextOverflow = useCallback((e) => {
    const { pageId, overflowBlock, overflowPageId } = e.detail;
    let overflowContents = undefined;

    // Find which content fits inside the boundaries of the page
    // if (editorRef?.current) {
      // const editor = editorRef.current.getEditor();
      const editor = ref.current.querySelector('.ql-editor');
      ref.current.style.paddingBottom = '0px';
      // console.log("Text overflow event received!! ", overflowBlock.uuid, ref.current, editor);

      const currentPage = document.getElementById(`complex-page-${pageId}`);
      const currentPageRect = currentPage.getBoundingClientRect();
      const maxHeight = currentPageRect.top + parseInt(currentPage.style.minHeight.replaceAll('px', ''));
      const editorRect = ref.current.getBoundingClientRect();

      console.log("Page rect :: ", maxHeight, editorRect);

      // Check if editor is still in play area
      let firstTextNode = editor.childNodes[0]; // TODO : handle case with no text nodes (BR tag possibility)
      while (firstTextNode && firstTextNode.nodeType !== 3) {
        firstTextNode = firstTextNode.childNodes[0];
      }
      const heightOfFirstLine = firstTextNode ? getBounds(firstTextNode, 0).height : editor.childNodes[0].getBoundingClientRect().height;

      // console.log("heightOfFirstLine :: ", heightOfFirstLine);

      if (editorRect.top > maxHeight || (editorRect.top + heightOfFirstLine > maxHeight)) {
        if (removeTextFromParentPage) removeTextFromParentPage(overflowPageId);
        // console.log("Text block itself is removed from page!!");
        return;
      } else {  // At least first line fits the page
        // console.log("Text block getLines :: ", editor);
        let lineThatBreaks;
        let lineIndex = 0;

        for (; lineIndex < editor.children.length; lineIndex++) {
          lineThatBreaks = editor.children[lineIndex];
          const bounds = lineThatBreaks.getBoundingClientRect();
          if (bounds.top + bounds.height > maxHeight) {
            break;
          }
        }

        const allTextNodes = getAllTextNodesWithinElement(lineThatBreaks);
        let textNodeThatFits
        // console.log({ allTextNodes });

        let textNodesIndex = 0;
        let foundTextNode = false;
        for (textNodesIndex = 0; textNodesIndex < allTextNodes.length; textNodesIndex++) {
          const bounds = getBounds(allTextNodes[textNodesIndex], allTextNodes[textNodesIndex].textContent.length - 1);
          if (bounds.top + bounds.height > maxHeight) {
            const startingBounds = getBounds(allTextNodes[textNodesIndex], 0);
            if (startingBounds.top + startingBounds.height <= maxHeight) {
              textNodeThatFits = allTextNodes[textNodesIndex];
            }
            // console.log("text bounds :: ", textNodeThatFits?.textContent, startingBounds.top + startingBounds.height, bounds.top + bounds.height, maxHeight);
            foundTextNode = true;
            break;
          }
          textNodeThatFits = allTextNodes[textNodesIndex];
        }

        // console.log({ lineThatBreaks, textNodeThatFits, lineIndex, foundTextNode });

        if (!foundTextNode || textNodeThatFits === undefined) {
          if (updateOverflowContents) {
            const firstNode = allTextNodes[0]?.parentNode || lineThatBreaks.childNodes[0];
            let splitIndex = firstNode.parentNode.nodeName === 'LI'
             ? parseInt(firstNode.getAttribute('data-op-index')) - 1
             : parseInt(firstNode.getAttribute('data-op-index'));
            console.log("Split index :: ", firstNode.parentNode, splitIndex);
            updateOverflowContents({
              contentSplitIndex: splitIndex,
            }, overflowBlock, overflowPageId);
          }
          return;
        }

        const totalCharacters = textNodeThatFits.textContent.length;
        let leftLength = 0, rightLength = totalCharacters, median = leftLength;
        while (median >= 0 && leftLength < rightLength) {
          median = Math.round((leftLength + rightLength) / 2);
          if (median === rightLength) break;
          let previousBounds = median - 1 > 0 ? getBounds(textNodeThatFits, median - 1) : undefined;
          let bounds = getBounds(textNodeThatFits, median);
          let nextBounds = median + 1 < totalCharacters ? getBounds(textNodeThatFits, median + 1) : undefined;
          // console.log("First while bounds :: ", leftLength, rightLength, median, textNodeThatFits.textContent.slice(median - 2, median + 5));
          if (bounds.top + bounds.height < maxHeight) {
            if (nextBounds && nextBounds.top + nextBounds.height > maxHeight) {
              // console.log("Coming here 1 :: ", textNodeThatFits.textContent.slice(median - 2, median + 5));
              median = median + 1;
              break;
            } else {
              leftLength = median;
            }
          } else {
            if (previousBounds && previousBounds.top + previousBounds.height < maxHeight) {
              // console.log("Coming here 2 :: ", textNodeThatFits.textContent.slice(median - 2, median + 5));
              break;
            } else {
              rightLength = median;
            }
          }
        }
        median = Math.round(median);
        if (lineIndex === editor.children.length && textNodesIndex === allTextNodes.length && median === rightLength) {
          console.log("Node fits precisely!!! ");
          return;
        }
        let keepLine = false;
        if (median === rightLength) {
          console.log('Case where all of this node fits!!!');
          keepLine = true;
        }
        // console.log("After first while loop ", median, overflowBlock.uuid);
        // Split content that does not fit
        /*const overflowDiv = document.createElement('div');
        let moveLines = [];
        if (lineIndex < editor.childNodes.length) {
          moveLines = Array.from(editor.childNodes).slice(lineIndex);
          moveLines.forEach(line => overflowDiv.appendChild(line.cloneNode(true)));
        }
        // overflowContents = PasteSmart.convert(moveLines);
        console.log({ overflowContents, moveLines });*/
        // Modify the current block contents to shrink
        /*if (overflowContents.length !== 0) {
          const changes = editor.setContents(editor.getContents(0, median));
        }*/
        // Add the second half of the content to the overflow block
        if (updateOverflowContents) {
          /*let splitIndex = textNodeThatFits.parentNode.parentNode.nodeName === 'LI' && !keepLine
             ? parseInt(textNodeThatFits.parentNode.getAttribute('data-op-index')) - 1
             : parseInt(textNodeThatFits.parentNode.getAttribute('data-op-index'));*/
          let splitIndex = parseInt(textNodeThatFits.parentNode.getAttribute('data-op-index'));
          console.log("Split Index :: ", textNodeThatFits.parentNode.parentNode.nodeName, splitIndex)
          updateOverflowContents({
            contentSplitIndex: splitIndex,
            textSplitIndex: median
          }, overflowBlock, overflowPageId);
        }
      }
    // }

  }, [updateOverflowContents]);

  useEffect(() => {
    if (ref?.current && editorRef?.current) {
      /*ref.current.addEventListener('resizeStart', e => {
        let editor = editorRef?.current.getEditor();
        contentRef.current = JSON.parse(JSON.stringify(editor.getContents().ops));
        logger("Before :: ", JSON.parse(JSON.stringify(editor.history.stack)));
      });*/
      ref.current.addEventListener('resizeStart', e => {
        const quillNode = ref.current.children[0];
        const quillEditor = quillNode.children[0];
        contentRef.current = quillEditor.cloneNode(true);
        quillEditor.style.display = 'none';
        contentRef.current.children[0].classList.add('ql-replica');
        quillNode.appendChild(contentRef.current);
      });
      ref.current.addEventListener('resizeEnd', e => {
        if (contentRef.current) {
        const quillNode = ref.current.children[0];
        const quillEditor = quillNode.children[0];
        quillNode.removeChild(contentRef.current);
        quillEditor.style.display = 'block';
        contentRef.current = null;
        }
      });
      ref.current.addEventListener('resize', debouncedResizeRequest);
      ref.current.addEventListener('updateContentsOnResizeEnd', e => {
        const { scaling } = e.detail;
        if (contentRef.current) {
          const quillNode = ref.current.children[0];
          const quillEditor = quillNode.children[0];
          quillNode.removeChild(contentRef.current);
          quillEditor.style.display = 'block';
          contentRef.current = null;
        }
        let editor = editorRef?.current.getEditor();
          const newContents = editor.getContents().ops.map(content => {
            if (content.attributes?.size) {
              const newFontSize = Number.parseFloat(`${content.attributes.size}`.replaceAll('px', '')) * scaling;
              return Object.assign({}, content, {
                attributes: Object.assign({}, content.attributes, {
                  size: `${parseFloat(newFontSize).toFixed(3)}px`
                })
              })
            } else if (content.attributes['block-size']) {
              const newFontSize = Number.parseFloat(`${content.attributes['block-size']}`.replaceAll('px', '')) * scaling;
              return Object.assign({}, content, {
                attributes: Object.assign({}, content.attributes, {
                  ['block-size']: `${parseFloat(newFontSize).toFixed(3)}px`
                })
              })
            }
            return content;
          });
        const delta = editor.setContents(newContents, 'user');
      })
      ref.current.addEventListener('changeScaling', e => {
        let editor = editorRef?.current.getEditor();
        const { scaling, style } = e.detail;
        logger("After :: ", scaling, JSON.parse(JSON.stringify(editor.history.stack)));
        if (editor) {
          const newContents = editor.getContents().ops.map(content => {
            if (content.attributes?.size) {
              const newFontSize = Number.parseFloat(`${content.attributes.size}`.replaceAll('px', '')) * scaling;
              return Object.assign({}, content, {
                attributes: Object.assign({}, content.attributes, {
                  size: `${parseFloat(newFontSize).toFixed(3)}px`
                })
              })
            } else if (content.attributes['block-size']) {
              const newFontSize = Number.parseFloat(`${content.attributes['block-size']}`.replaceAll('px', '')) * scaling;
              return Object.assign({}, content, {
                attributes: Object.assign({}, content.attributes, {
                  ['block-size']: `${parseFloat(newFontSize).toFixed(3)}px`
                })
              })
            }
            return content;
          });
          parentStyleRef.current = style;
          // editor.setContents(contentRef.current, 'api');
          editor.setContents(newContents, 'user');
          const quillNode = ref.current.children[0];
          const quillEditor = quillNode.children[0];
          quillNode.removeChild(contentRef.current);
          contentRef.current = null;
          quillEditor.style.display = 'block';
          logger("newContents ::", newContents, contentRef.current);
          // quillContentChangeHandler();
        }
      });
    }
    let cleanUp;
    if (ref?.current) {
      cleanUp = ref.current;
      ref.current.addEventListener('updateFontFamilySizeEvent', updateQuillContents);
      ref.current.addEventListener('updateGridCellDataEvent', updateQuillContents);
      ref.current.addEventListener('textOverflow', onTextOverflow);
      ref.current.addEventListener('elementFocus', e => {
        // get the document level scroll element top and apply the scroll top after focus for preserving the position of the
        // cursor inside the text element in creative block
        const scrollElement = document.getElementById('complex-page-wrapper');
        const oldScrollTop = scrollElement.scrollTop;
        const focus = (e) => {
          const editor = editorRef?.current?.getEditor();
          if (editor) {
            setCursorOnClick(e.detail, editor);
            editor.focus();
            scrollElement.scrollTop = oldScrollTop;
            toggleToolbarForceRender(previousValue => !previousValue);
          }
        };
        if (!textEditable) {
          const cb = setTextEditable(true);
          requestAnimationFrame(() => {
            focus(e)
            if (cb) {
              cb()
            }
          });
        } else {
          focus(e);
        }
      });
    }
    return(()=>{
      if (cleanUp) {
        cleanUp.removeEventListener('updateFontFamilySizeEvent', updateQuillContents);
        cleanUp.removeEventListener('updateGridCellDataEvent', updateQuillContents);
      }
    })
  }, [debouncedResizeRequest, onTextOverflow, textEditable]);

  const updateQuillContents = useCallback(e => {
    const { action, source = 'user' } = e.detail;
    const quill = editorRef?.current?.getEditor() || null;
    if (action === 'update') {
        const quill = editorRef?.current?.getEditor() || null;
        if (quill) {
          quill.setContents(defaultContent, source);
        }
        if (source === 'silent') {
          defaultContentRef.current = defaultContent;
        }
    } else if (action === 'undo') {
      quill.history.customUndo();
    } else if (action === 'redo') {
      quill.history.customRedo();
    }
  }, [defaultContent]);

  useEffect(() => {
    if (isMailSubject) {
      defaultContentRef.current = defaultContent;
    }
  }, [isMailSubject, defaultContent]);

  const updateTextAlignment = useCallback(e => {
    const { uuid, action, position } = e.detail;
    if(uuid === itemUUID) {
      const quill = editorRef?.current?.getEditor() || null;
      if(quill) {
        if(action === 'update') {
          quill.setSelection(0, quill.getLength());
          quill.format('align', position, 'user');
        } else if(action === 'undo') {
          quill.history.customUndo();
        } else if(action === 'redo') {
          quill.history.customRedo();
        }
      }
    }
  }, [itemUUID]);

  useEffect(() => {
    let cleanUp;
    if (ref?.current) {
      cleanUp = ref.current;
      ref.current.addEventListener('updateFontFamilySizeEvent', updateQuillContents);
      ref.current.addEventListener('updateGridCellDataEvent', updateQuillContents);
      ref.current.addEventListener('changeTextAlignment', updateTextAlignment);
    return ()=>{
      if (cleanUp) {
        cleanUp.removeEventListener('updateFontFamilySizeEvent', updateQuillContents);
        cleanUp.removeEventListener('updateGridCellDataEvent', updateQuillContents);
        cleanUp.removeEventListener('changeTextAlignment', updateTextAlignment);
      }
    }
   }
  }, [updateQuillContents]);

  useEffect(() => {
    // event listener for updating editable and not editable content changes when email width changes.
    document.addEventListener("updateQuillContentsOnWidthChange", updateQuillContents);
    return () => document.removeEventListener("updateQuillContentsOnWidthChange", updateQuillContents);
  }, [updateQuillContents]);

  useEffect(() => {
    const existingStack = editorMap?.current?.get(itemUUID);
    if (existingStack) {
      if (editorRef.current) {
        const editor = editorRef.current.getEditor();
        editor.history.setInitialStack(existingStack);
      } else {
        setTextEditable(true);
        requestAnimationFrame(() => {
          const editor = editorRef?.current?.getEditor();
          if (editor) {
            editor.history.setInitialStack(existingStack);
          }
        });
      }
    }
  }, []);

  const toggleAILoader = flag => {
    updateArtboard({
      [CONTEXT_KEYS.AI_LOADER]: flag,
    });
  };

  const generateAndInsertTextInEditor = () => {
    editor && editor.focus();
    if (editorRef.current) {
      toggleAILoader(true);
      editor &&
        generateAndInsertText(t, editor, (isError = false, failureMessage = undefined) => {
          toggleAILoader(false);
          if(isError) {
            message.error(t(COMPLEX_PAGE_OPTIONS.TEXT_GENERATION_FAILED.key, COMPLEX_PAGE_OPTIONS.TEXT_GENERATION_FAILED.value));
          }
          if (failureMessage !== undefined) {
            updateArtboard({
              [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
                visible: true,
                failureMessage,
              },
            });
          }
        });
    }
  };

  const MODULES = useMemo(() => {
    return {
      toolbar: {
        container: `#toolbar-${itemUUID}`,
        handlers: {
          list: function(value) {
            let range = this.quill.getSelection();
            let formats = this.quill.getFormat(range);
            if (value === 'check') {
              if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
                this.quill.format('list', false, Quill.sources.USER);
              } else {
                this.quill.format('list', 'unchecked', Quill.sources.USER);
              }
            } else {
              if (value === 'ordered') {
                this.quill.format('list', value, Quill.sources.SILENT);
                this.quill.format('block-start', 1, Quill.sources.USER);
              } else {
                this.quill.format('list', value, Quill.sources.USER);
              }
            }
          },
          link: function (value) {
            let range = this.quill.getSelection();
            let contents = this.quill.getContents(range.index, range.length);
            if (value) {
              let hasVariable = false;
              let preview = contents.ops
                .map(item => {
                  if (item?.insert?.mention && item?.insert?.mention?.id) {
                    hasVariable = true;
                    return `{${item?.insert?.mention.id}}`;
                  }
                  return item.insert;
                })
                .join('')
                .trim();
              if (hasVariable) {
                let changes = new Delta().retain(range.index).delete(range.length);
                contents.ops.forEach(op => {
                  changes = changes.insert(
                    op.insert,
                    Object.assign({}, op.attributes, {
                      link: preview,
                    }),
                  );
                });
                this.quill.updateContents(changes, Quill.sources.USER);
                return;
              }
              if (range == null || range.length === 0) return;
              if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
                preview = 'mailto:' + preview;
              }
              const tooltip = this.quill.theme.tooltip;
              tooltip.edit('link', preview);
            } else {
              this.quill.format('link', false, 'user');
            }
          }
        },
      },
      keyboard: {
        bindings: {
          tab: {
            key: 9,
            handler: function handler(range) {
              this.quill.history.cutoff();
              const formats = this.quill.getFormat(range.index);
              const newFormats = Object.assign({}, formats);
              Object.keys(formats).forEach(blockFormat => {
                if (blockFormat.startsWith('block-')) {
                  const formatKey = blockFormat.replaceAll('block-', '');
                  if (newFormats[formatKey] === undefined) {
                    newFormats[formatKey] = formats[blockFormat] === 'normal' ? false : formats[blockFormat];
                  }
                }
                if (blockFormat === 'heading') {
                  delete newFormats['heading'];
                }
              })
              const delta = new Delta().retain(range.index).delete(range.length).insert('    ', newFormats);
              this.quill.updateContents(delta, Quill.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range.index + 4, Quill.sources.SILENT);
            }
          },
          bold: {
            key: 'b',
            shortKey: true,
            handler: function handler(range, context) {
              const formats = this.quill.getFormat(range.index);
              const fontDetails = fontListRef.current.fontVarients.find(font => font.name === formats.font);
              if (fontDetails && fontDetails.variants['bold']) {
                this.quill.formatText(range, 'bold', formats['bold'] ? false : true, 'user');
              }
            }
          },
          italic: {
            key: 'i',
            shortKey: true,
            handler: function handler(range, context) {
              const formats = this.quill.getFormat(range.index);
              const fontDetails = fontListRef.current.fontVarients.find(font => font.name === formats.font);
              if (fontDetails && fontDetails.variants['italic']) {
                this.quill.formatText(range, 'italic', formats['italic'] ? false : true, 'user');
              }
            }
          },
          'list autofill': {
            key: ' ',
            collapsed: true,
            format: {
              list: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler(range, context) {
              const { prefix } = context;
              const start = parseInt(prefix.replace('.', ''), 10);
              if (typeof start === 'number' && !isNaN(start)) {
                this.quill.formatLine(range.index, 1, 'list', `ordered`);
                this.quill.formatLine(range.index, 1, 'block-start', start);
                this.quill.deleteText(range.index - prefix.length, prefix.length, 'user');
              } else {
                // quill default list autofill keyboard bindings - START
                let length = context.prefix.length;
                let [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch (context.prefix.trim()) {
                  case '[]':
                  case '[ ]':
                    value = 'unchecked';
                    break;
                  case '[x]':
                    value = 'checked';
                    break;
                  case '-':
                  case '*':
                    value = 'bullet';
                    break;
                  default:
                    value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', Quill.sources.USER);
                this.quill.history.cutoff();
                let delta = new Delta()
                  .retain(range.index - offset)
                  .delete(length + 1)
                  .retain(line.length() - 2 - offset)
                  .retain(1, { list: value });
                this.quill.updateContents(delta, Quill.sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, Quill.sources.SILENT);
                // quill default list autofill keyboard bindings - END
              }
            },
          },
          'list enter': {
            key: 13,
            collapsed: true,
            format: {list: true},
            handler (range, context) {
              // quill default enter keyboard bindings - START
              if (range.length > 0) {
                this.quill.scroll.deleteAt(range.index, range.length);  // So we do not trigger text-change
              }
              let lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                if (Parchment.query(format, Parchment.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                  lineFormats[format] = context.format[format];
                }
                return lineFormats;
              }, {});
              this.quill.insertText(range.index, '\n', lineFormats, Quill.sources.USER);
              // Earlier scroll.deleteAt might have messed up our selection,
              // so insertText's built in selection preservation is not reliable
              this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
              this.quill.focus();
              Object.keys(context.format).forEach((name) => {
                if (lineFormats[name] != null) return;
                if (Array.isArray(context.format[name])) return;
                if (name === 'link') return;
                if (name === 'heading') return;
                this.quill.format(name, context.format[name], Quill.sources.USER);
              });
              // quill default enter keyboard bindings - END

              // for numbered list
              const { format } = context;
              const prevBlockStart = Number(format['block-start']);
              if (prevBlockStart && typeof prevBlockStart === 'number' && !isNaN(prevBlockStart)) {
                this.quill.formatLine(range.index + 1, 1, 'block-start', prevBlockStart + 1, 'user');
              }
            }
          },
          'arrow left': {
            key: 37,
            handler(range, context) {
              const [embedBlot] = this.quill.scroll.descendant(Quill.imports['formats/mention'], range.index);
              if (embedBlot) {
                console.log({ embedBlot })
                this.quill.setSelection(range.index - 1, Quill.sources.USER);
                return false;
              }
              return true;
            }
          },
          enter: {
            key: 13,
            shiftKey: null,
            handler: function handleEnter(range, context) {
              if (range.length > 0) {
                this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
              }
              const newLineFormats = {};
              var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
                if (Parchment.query(format, Parchment.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                  lineFormats[format] = context.format[format];
                } else if (format === 'font') {
                  lineFormats['block-font'] = context.format[format];
                } else if (format === 'size') {
                  lineFormats['block-size'] = context.format[format];
                }
                return lineFormats;
              }, {});
              this.quill.insertText(range.index, '\n', lineFormats, Quill.sources.USER); // Earlier scroll.deleteAt might have messed up our selection,
              // so insertText's built in selection preservation is not reliable

              this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
              this.quill.focus();
              Object.keys(context.format).forEach((name) => {
                if (lineFormats[name] != null) return;
                if (Array.isArray(context.format[name])) return;
                if (name === 'link') return;
                if(name === 'heading') return;
                this.quill.format(name, context.format[name], Quill.sources.USER);
              });
            }
          }
        }
      },
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
        // matchers: [[Node.TEXT_NODE, customMatcher]],
        matchers: [
          ['P', customParagraphMatcher],
          ['LI', customParagraphMatcher],
          ['PRE', customCodeMatcher],
          ['CODE', customCodeMatcher],
          ['IMG', defaultMatcher]
        ],
        fontList: () => {
          return fontListRef.current;
        },
        isInsideCustomLogicPopup: itemUUID === 'custom-logic'
      },
      history: {
        userOnly: true,
        delay: 3000,
        maxStack: 999999,
        callback: onChange,
        historyCallback: onHistoryChange,
        itemUUID,
        customize: customizeHistory
      },
      ...(!disableVariables
        ? {
            variableMention: {
              mentionDenotationChars: ['$'],
              disabled: false,
              uuid: itemUUID,
              toggleVariablePopup: (...val) => toggleVariablePopup(...val),
              isEmail: false,
              isPreview: isPreview,
            },
          }
        : {}),

      ...(enableFunctionCall ? {
        logicMention: {
          mentionDenotationChars: ['@'],
          disabled: false,
          uuid: itemUUID,
          toggleLogicPopup: (...val) => toggleLogicPopup(...val),
          isEmail: false,
          isPreview: isPreview,
        },
      } : {}),
      customTooltip: {
      }
    };
  }, [isPreview, enableFunctionCall]);

  const assignVariableHandler = e => {
    logger('Assign Variable');

    let editor = editorRef?.current?.getEditor();

    let range = editor?.getSelection();
    let bounds = range ? editor?.getBounds(range) : undefined;

    let selectedValue = editor?.getText(range);

    setAssignVariablePopup(previous => {
      return {
        isVisible: true,
        left: bounds.left + 'px',
        top: bounds.top + bounds.height + 10 + 'px',
        defaultSearch: selectedValue,
      };
    });

    logger('assignVariableHandler :: range', range);
    logger('assignVariableHandler :: bounds', bounds);
  };

  const dateFormatOption = () => {
    const quill = editorRef?.current?.getEditor() || null;
    let element = quill?.scrollingContainer;
    if (element) {
      element.addEventListener('mouseover', onMouseOver);
      element.addEventListener('click',popupCustomLogic)
    }
    // TODO : Check if removelistener should also be implemented? whether this is available in readonly
  };

  const popupCustomLogic = useCallback(
    event => {
      setChangedFormat(undefined);
      setSelectedDateVar('');
      if (isInteractiveDesign) return;
      const currentElement = event.target.parentElement.parentElement.parentNode;
      const dataValue = currentElement.getAttribute('data-value');
      const quill = editorRef?.current?.getEditor();
      if (dataValue === 'custom_logic' && quill) {
        const defaulValue = currentElement.getAttribute('data-extra-info');
        const blotIndex = quill.getIndex(currentElement.__blot.blot);
        let defaultContent1 = JSON.parse(defaulValue);
        setDefaultCustomLogicContent(defaultContent1);
        if (isFromCreativeBlock && !quill.hasFocus()) return;
        const position = quill.getBounds(blotIndex);
        if (position) {
          setCustomLogicPosition(position);
          toggleCustomLogicPopup(true);
        }
      } else {
        setDefaultCustomLogicContent();
        toggleCustomLogicPopup(false);
      }
    },
    [isFromCreativeBlock, isInteractiveDesign],
  );

  const toggleVariablePopup = (show, variableTerm, position) => {
    toggleShowMentionPopup(show);
    setVariableTerm(variableTerm);
    setVariablePosition(position);
    const quill = editorRef?.current?.getEditor();
    if(!show && quill){
      if (quill.getModule('variableMention')) {
        quill.getModule('variableMention').resetPreviousER();
      }
    }
  };

  const toggleLogicPopup = (show, variableTerm, position) => {
    toggleShowLogicMentionPopup(show);
    toggleCustomLogicPopup(false);
    setLogicTerm(variableTerm);
    setLogicPosition(position);
  };

  const onVariableSelect = useCallback(data => {
    const quill = editorRef?.current?.getEditor();
    // TODO : Clarify why this boolean is used
    let isComplexDesign = false;
    var delta = quill.getContents();
    delta.ops.forEach(content => {
      if(data.type === 'ListString' && content?.insert?.toString()?.includes('$')) {
        if(content?.insert?.toString() !== '$') {      
          isComplexDesign = true;
        } 
      }
    })
    let vtype = 'assigned';
    const variableName = data.displayName ? data.displayName : data.placeHolderText;
    const isRelationShip = data.type === PERFECTDOC_RELATIONSHIP;
    quill
      .getModule('variableMention')
      .onVariableSelect(variableName, data.id, data.length, vtype, data.type, data.count, isComplexDesign, undefined, data.placeHolderText, isRelationShip);
    if(!isRelationShip){
      toggleVariablePopup(false);
      setVariableTerm('');
    } 
  }, []);

  const onLogicSelect = data => {
    if (data?.id === 5) {
      toggleCustomLogicPopup(true);
      setCustomLogicPosition(logicPosition);
      setDefaultCustomLogicContent();
      return ;
    }
    const quill = editorRef?.current?.getEditor();
    const variableName = data?.value;
    quill
      .getModule('logicMention')
      .onLogicSelect(
        variableName,
        data?.placeHolderText,
        data?.contents,
      );
    toggleShowMentionPopup(false);
    setVariableTerm('');
  };

  const onSaveCustomLogic = quillData => {
    const data = { id: 5, value: 'custom_logic', placeHolderText: 'custom_logic' };
    const variableName = data.value;
    let tooltipTitle = '';
    for (let i = 0; i < quillData.contents.length; i++) {
      if (quillData.contents[i].style?.isVariable === true) {
        const variableId = Number(quillData.contents[i].content.replace(/\D/g, ''));
        const variableDetails = globalVariables.filter(globalVar => globalVar.id === variableId)[0];
        tooltipTitle += variableDetails.placeHolderText;
      }
      else {
        tooltipTitle += quillData.contents[i].content;
      }
    }
    let isNew = true;
    const quill = editorRef?.current?.getEditor();
    let insertPosition;
    let range;
    if (defaultCustomLogicContent && quill) {
      range = quill.getSelection(true);
      let index = range.index;
      while (index > 0) {
        const [leafBlot] = quill.getLeaf(index);
        if (leafBlot?.next?.domNode?.dataset?.placeHolderText === 'custom_logic') {
          break;
        } else if (leafBlot?.domNode?.dataset?.placeHolderText === 'custom_logic') {
          if (isFromCreativeBlock || isCreativeStaticBlock) {
            index -= 1;
          }   
          break;
        }
         index -= 1;
      }
      isNew = false;
      insertPosition = index;
    }
    quill
      .getModule('logicMention')
      .onLogicSelect(
        variableName,
        data.placeHolderText,
        quillData.contents,
        tooltipTitle,
        isNew,
        insertPosition,
        range
      );
    toggleCustomLogicPopup(false);
    toggleLogicPopup(false);
    setDefaultCustomLogicContent();
  };

  const onMentionPopupHide = useCallback(() => {
    toggleVariablePopup(false);
    toggleLogicPopup(false);
  }, []);

  const onMouseOver =  useCallback((event) => {
    if(changedFormatRef.current) return;
    const quill =  editorRef?.current?.getEditor();
    let targetElement = quill?.scrollingContainer;
    let variableData = {};
    let target = event.target;
    let dateVariable = '';
    const elementPos = targetElement?.getBoundingClientRect();
    if (target?.getAttribute('data-variable-type') === 'Date') {
      dateVariable = target;
    } else if (target?.parentNode?.getAttribute('data-variable-type') === 'Date') {
      dateVariable = target.parentNode;
    } else if(target?.children[0]?.children[0]?.getAttribute('data-variable-type') === 'Date') {
      dateVariable = target?.children[0]?.children[0];
    }
    if (dateVariable) {
      const delta = quill?.getContents();
      let varElement = {};
      delta.ops.map(element => {
      if(element.insert.mention && element.insert.mention.variableType === "Date") {
        // TODO : Does not cover more than one date variables with same value
        if(dateVariable.getAttribute('data-value') === element.insert.mention.value) {
          varElement = JSON.parse(JSON.stringify(element));
        }
      }})
      setSelectedDateVar('');
      let variablePos = dateVariable.getBoundingClientRect();
      const container = document.getElementById(`q-container-${itemUUID}`);
      const {paddingTop, paddingLeft} = getComputedStyle(container);
      const paddingTopVal = parseFloat(paddingTop)  || 0;  
      const paddingLeftVal = parseFloat(paddingLeft)  || 0;    
      variableData.posY = ((variablePos.y - elementPos.y - 5)+ paddingTopVal) / scaling;
      variableData.posX = ((variablePos.x - elementPos.x)+ paddingLeftVal) / scaling ;
      variableData.height = (variablePos.height + 10) / scaling;
      variableData.width = variablePos.width / scaling;
      variableData.id = dateVariable.getAttribute('data-id');
      variableData.dateFormat =
        varElement?.insert?.mention?.dateFormat ||
        dateVariable.getAttribute('data-date-format') ||
        process.env.REACT_APP_VARIABLE_DATE_FORMAT;
      variableData.placeHolderText = varElement?.insert?.mention?.placeHolderText;
      setSelectedDateVar(variableData);
    } else {
      setSelectedDateVar(editIconClicked ? selectedDateVar : '');
    }
  } , [editorRef?.current?.getEditor(), scaling]);

  // TODO : Can this not be added to the current selection / get date position instead of setContents
  const changeDateFormat = useCallback((format) => {
    const quill = editorRef?.current?.getEditor(); 
    quill.focus();   
    const delta = quill?.getContents();
    let newContents = delta.ops.map(element => {
      if(element.insert.mention && element.insert.mention.variableType === "Date") {
        let varElement = JSON.parse(JSON.stringify(element));
        varElement = {
          ...varElement,
          insert: {
            ...varElement.insert,
            mention: {
              ...varElement.insert.mention,
              dateFormat: format,
            }
          }
        }
        return Object.assign({}, varElement, {
          attributes: Object.assign({}, element.attributes, {
            dateFormat: format,
          })
        })
      }
      return element;
    });
    let saveContent = {
      ops: [...newContents]
    }
    quill.setContents(saveContent, 'user');
    setSelectedDateVar('');
    setChangedFormat(undefined);
  }, []);

  const setCursorOnClick = (event, editor) => {
    if (!editable) return;
    const { clientX, clientY, reAddAreaElementStyles, removeAreaElementStyles } = event;
    !textEditable && removeAreaElementStyles && removeAreaElementStyles();
    if (document.caretPositionFromPoint) {
      // for firefox
      const range = document.caretPositionFromPoint(clientX, clientY);
      range && editor && editor.selection.setNativeRange(range.offsetNode, range.offset);
    } else if (document.caretRangeFromPoint) {
      // for chrome and other browsers
      const range = document.caretRangeFromPoint(clientX, clientY);
      range && editor && editor.selection.setNativeRange(range.startContainer, range.startOffset);
    }
    !textEditable && reAddAreaElementStyles && reAddAreaElementStyles();
  };

  const quillContainerDoubleClick = event => {
    if (!editable) return;
    if (!isPreview && !isFromCreativeBlock && !editor?.hasFocus()) {
      if (!textEditable) {
        const cb = setTextEditable(true);
        event.persist();
        requestAnimationFrame(() => {
          if (cb) {
            cb();
          }
          const editor = editorRef?.current?.getEditor();
          setCursorOnClick(event, editor);
        });
      } else if (textEditable) {
        const editor = editorRef?.current?.getEditor();
        setCursorOnClick(event, editor);
      }
    }
    onContainerClick();
  };

  if (isPreview || !textEditable) {
  return (
    <QuillContainer
      editable={editable}
      ref={ref}
      id={`q-container-${itemUUID}`}
      data-uuid={itemUUID}
      style={{
        position: 'relative',
        zIndex: selected ? 2 : 0,
        overflow: selected ? 'visible' : 'hidden',
        minHeight: 'fit-content',
        backgroundColor: backgroundColor,
        paddingTop: padding.top,
        paddingBottom: padding.bottom,
        paddingLeft: padding.left,
        paddingRight: padding.right,
        display: invisible ? 'none' : 'block',
        borderRadius: border_radius
      }}
      className={`${customClassName} ${selected ? 'selected' : 'no-cursor'}`}
      onClick={onContainerSingleClick}
      onDoubleClick={quillContainerDoubleClick}
      onMouseMove={onMouseMove}
    >
      <div className='quill'>
        <div className='ql-container ql-snow ql-preview'>
          {children}
        </div>
      </div>
    </QuillContainer>
  )
  }
  
  return (
    <QuillContainer
      editable={editable}
      ref={ref}
      id={`q-container-${itemUUID}`}
      data-uuid={itemUUID}
      style={{
        position: 'relative',
        zIndex: selected ? 2 : 0,
        overflow: selected ? 'visible' : 'hidden',
        minHeight: 'fit-content',
        backgroundColor: backgroundColor,
        paddingTop: padding.top,
        paddingBottom: padding.bottom,
        paddingLeft: padding.left,
        paddingRight: padding.right,
        display: invisible ? 'none' : 'block',
        borderRadius: border_radius
      }}
      className={`${customClassName} ${selected ? 'selected' : 'no-cursor'}`}
      onClick={onContainerSingleClick}
      onDoubleClick={quillContainerDoubleClick}
      onMouseMove={onMouseMove}
    >
      {children}
      {document.getElementById(toolbarDOM) && (
        <>
          {ReactDOM.createPortal(
            <TextBlockToolbar
              isToolBarVisible={!readOnly && noFocus ? true : editor?.hasFocus()}
              itemUUID={itemUUID}
              editorRef={editorRef}
              enableSideBar={enableSideBar}
              forceRender={forceRender}
              containerRef={parentStyleRef}
              isAbsolute={isFontSidebarAbsolute}
              invisible={invisible || itemUUID.endsWith('-row')}
              toolbarInvisible={toolbarInvisible}
              isTocTitleBlock={isTocTitleBlock}
            />,
            document.getElementById(toolbarDOM),
          )}
          <ReactQuill
            ref={editorRef}
            modules={MODULES}
            formats={FORMATS}
            readOnly={readOnly}
            defaultValue={defaultContentRef.current}
            placeholder={!readOnly && isPlaceholderVisible ? t(
              COMPLEX_PAGE_OPTIONS.EMPTY_CREATIVE_BLOCK_PLACEHOLDER.key,
              COMPLEX_PAGE_OPTIONS.EMPTY_CREATIVE_BLOCK_PLACEHOLDER.value,
            ): null}
            onChange={quillContentChangeHandler}
            onChangeSelection={quillContentSelectionHandler}
            onFocus={quillFocusHandler}
            onBlur={quillBlurHandler}

          />
        </>
      )}

      {selected && !isFromCreativeBlock && enableAI && !isTocTitleBlock && (
        <ContextMenu
          documentId={`q-container-${itemUUID}`}
          scaling={1}
          swapElements={dummyCallback}
          handleModal={dummyCallback}
          multiSelectedElementIds={[]}
          showGenerateText={editorRef?.current?.getEditor().getSelection()?.length > 0}
          generateTextHandler={generateAndInsertTextInEditor}
          assignVariableHandler={assignVariableHandler}
          textBlock={{
            editorRef: editorRef,
          }}
        />
      )}
      {/*
        <>
          <AtMentions
            {...assignVariblePopup}
            setAssignVariablePopup={setAssignVariablePopup}
            editorRef={editorRef}
          />
        </>
      */}
      {!isTocTitleBlock && showMentionPopup && variablePosition?.left!=undefined && document.getElementById(variableDOM) &&
        ReactDOM.createPortal(
          <VariableMentionPopup
            quill={editorRef?.current?.getEditor()}
            searchTerm={variableTerm}
            onVariableSelect={onVariableSelect}
            onHide={onMentionPopupHide}
            position={variablePosition}
            uuid={itemUUID}
            types={EMPTY_ARRAY}
            globalVariables={globalVariables}
            relationships={relationships}
            localVariables={localVariables}
            updateGlobalVariables={addNewVariable}
            isMailSubject={isMailSubject}
            allowLocal={allowLocal}
            onUpdateLocalVariables={onUpdateLocalVariables}
            levels={levels}
          />,
          document.getElementById(variableDOM),
        )}

{!isTocTitleBlock && !showCustomLogicPopup &&
        showLogicMentionPopup &&
        document.getElementById(variableDOM) &&
        ReactDOM.createPortal(
          <LogicMentionPopup
            quill={editorRef?.current?.getEditor()}
            searchTerm={logicTerm}
            onVariableSelect={onLogicSelect}
            onHide={onMentionPopupHide}
            position={logicPosition}
            uuid={itemUUID}
          />,
          document.getElementById(variableDOM),
        )}

      {showCustomLogicPopup &&
        document.getElementById(variableDOM) &&
        ReactDOM.createPortal(
          <CustomLogicPopup
            quill={editorRef?.current?.getEditor()}
            contents={defaultCustomLogicContent}
            searchTerm={logicTerm}
            onVariableSelect={onLogicSelect}
            onSaveChanges={onSaveCustomLogic}
            onHide={onMentionPopupHide}
            position={customLogicPosition}
            uuid={itemUUID}
            editable={editable}
          />,
          document.getElementById(variableDOM),
        )}
        
      {selectedDateVar && (
        <Tooltip title={selectedDateVar?.placeHolderText} overlayClassName={'date-var-tooltip'} visible={tooltipVisible} onVisibleChange={(e) => setTooltipVisible(e)}>
        <DateVar
          id="dateVar" // TODO : Check if ID has to start with #
          isEmail={false}
          style={{
            height: selectedDateVar.height,
            width: selectedDateVar.width,
            transform: `translate3d(${selectedDateVar.posX}px, ${selectedDateVar.posY}px, 0px)`,
          }}
        >
          {selected && <Popover
            title=""
            trigger="click"
            content={
              <PopupContainer>
                <PopupLabel>{selectedDateVar?.placeHolderText}</PopupLabel>
                <PopupLabel>
                  {t(
                    `UPDATE_DATE_VARIABLE_FORMAT_POPUP:${UPDATE_DATE_VARIABLE_FORMAT_POPUP.DATE_FORMAT_LABEL.key}`,
                    UPDATE_DATE_VARIABLE_FORMAT_POPUP.DATE_FORMAT_LABEL.value,
                  )}
                </PopupLabel>
                <Select
                  labelInValue // TODO : Check if read only mode is implemented
                  defaultValue={{ key: selectedDateVar?.dateFormat }}
                  style={{ width: '100%' }}
                  onChange={e => {
                    editorRef.current.getEditor().focus();
                    setChangedFormat(e.key)
                  }}
                >
                  <Option value="dd-MM-yy">dd-MM-yy</Option>
                  <Option value="dd-MM-yyyy">dd-MM-yyyy</Option>
                  <Option value="MM-dd-yyyy">MM-dd-yyyy</Option>
                  <Option value="yyyy-MM-dd">yyyy-MM-dd</Option>
                  <Option value="dd-MMM-yyyy">dd-MMM-yyyy</Option>
                  <Option value="EEEEE MMMMM yyyy">EEEEE MMMMM yyyy</Option>
                </Select>
                <PopupActionContainer>
                  <CancelButton size="default" onClick={() => { setChangedFormat(undefined); setSelectedDateVar('')}}>
                    {t(
                      `UPDATE_DATE_VARIABLE_FORMAT_POPUP:${UPDATE_DATE_VARIABLE_FORMAT_POPUP.CANCEL_UPDATE_DATE_FORMAT_BUTTON.key}`,
                      UPDATE_DATE_VARIABLE_FORMAT_POPUP.CANCEL_UPDATE_DATE_FORMAT_BUTTON.value,
                    )}
                  </CancelButton>
                  <SaveButton
                    type="primary"
                    size="default"
                    onClick={() => {
                      changeDateFormat(changedFormatRef.current, selectedDateVar);
                    }}
                  >
                    {t(
                      `UPDATE_DATE_VARIABLE_FORMAT_POPUP:${UPDATE_DATE_VARIABLE_FORMAT_POPUP.SAVE_DATE_FORMAT_BUTTON.key}`,
                      UPDATE_DATE_VARIABLE_FORMAT_POPUP.SAVE_DATE_FORMAT_BUTTON.value,
                    )}
                  </SaveButton>
                </PopupActionContainer>
              </PopupContainer>
            }
          >
            <div className={'edit-button'} onClick={() => {
              setTooltipVisible(false);
              setEditIconClicked(!editIconClicked)
            }}>
              <Icon type="edit" />
            </div>
          </Popover>}
        </DateVar>
        </Tooltip>
      )}
    </QuillContainer>
  );
};

export default React.forwardRef(TextBlockWithQuillRenderer);

/**
 * Custom Clipboard matcher for text nodeType in Quill
 * Quill's default clipboard matcher strips out spaces on populating the defaultValue props
 */
const customMatcher = function(node, delta) {

  function computeStyle(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return {};
    const DOM_KEY = '__ql-computed-style';
    return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
  }

  function isLine(node) {
    if (node.childNodes.length === 0) return false; // Exclude embed blocks

    const style = computeStyle(node);
    return ['block', 'list-item'].indexOf(style.display) > -1;
  }

  const text = node.data; // Word represents empty line with <o:p>&nbsp;</o:p>

  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }

  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }

  const newDelta = new Delta().insert(text);

  if (isLine(node) || (delta.length() > 0 && node.nextSibling && isLine(node.nextSibling))) {
    newDelta.insert('\n');
  }

  return newDelta;
};

const customParagraphMatcher = function(node, delta) {
  // console.log({ node, delta, something: this });
  if (node.style.cssText.includes('--font-size')) {
    // Copied from Quill
    return delta.compose(new Delta().retain(delta.length(),
      { fromQuill: true }));
  } else {
    // Copied from outside
    // Trying to find font size and font family
    let fontSize, fontFamily;
    if (node.style.font) {
      // can it be obtained from computed style
      // console.log("Font style attr :: ", node.style.font);
    }
    if (node.style.fontFamily) {
      fontFamily = node.style.fontFamily;
    }
    if (node.style.fontSize) {
      fontSize = node.style.fontSize;
    }
    if ((fontFamily === undefined || fontSize === undefined) && node.childNodes[0] && node.childNodes[0].style) {
      if (node.childNodes[0].style.fontFamily && fontFamily === undefined) {
        fontFamily = node.childNodes[0].style.fontFamily;
      }
      if (node.childNodes[0].style.fontSize && fontSize === undefined) {
        fontSize = node.childNodes[0].style.fontSize;
      }
    }

    if (fontFamily || fontSize) {
      // console.log({ fontSize, fontFamily });
      return delta.compose(new Delta().retain(delta.length(),
        { font: fontFamily, size: fontSize, ['block-font']: fontFamily, ['block-size']: fontSize }));
    }
  }
  return delta;
}

const defaultMatcher = function(node, delta) {
  return new Delta();
}

const customCodeMatcher = function(node, delta) {
  const newDelta = delta.compose(new Delta().retain(delta.length(),
      { ['code-block']: false, code: false }));
  return newDelta;
}
